

export default function LogoutComponent() {
  



  return (
    <div className="LogoutMessage">
      <h2>You have been logged out.</h2>
    </div>
  );
}
